import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { updateEstado, showEstado, loadEstados } from '~/store/modules/estado/action';



const Edit = () => {
  let history = useHistory();
  const [estadoEdit, setEstadoEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { estado_id } = useParams();
  const { estado, errors } = useSelector(({ EstadoReducer }) => EstadoReducer);

  useEffect(() => {
    dispatch(showEstado(estado_id));
  }, [dispatch, estado_id]);

  useEffect(() => {
    if (estado.id === parseInt(estado_id)) {
      setEstadoEdit(estado);
    }
  }, [estado, estado_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Entidade atualizada com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadEstados());
        }
      );
    }
  }, [updated, history, dispatch]);

  const handleClose = () => {
    history.goBack('/estado');
  };


  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(estadoEdit)) {
      let yup_errors = {};
      schema.validate(estadoEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateEstado(estadoEdit, estado_id));
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Estado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {estado.id === parseInt(estado_id) ? (
              <FormCad
                errors={errorsValidate}
                estado={estadoEdit}
                handleSubmit={handleSubmit}
                schema={schema}
                setEstado={setEstadoEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link className="btn btn-default" to="/estado">
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button className="btn btn-success" form="form_estado" type="submint">
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
